import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LottieAnimationViewComponent } from './lottieAnimationView.component';
var LottieAnimationViewModule = /*@__PURE__*/ (function () {
    function LottieAnimationViewModule() {
    }
    LottieAnimationViewModule.forRoot = function () {
        return {
            ngModule: LottieAnimationViewModule
        };
    };
    return LottieAnimationViewModule;
}());
export { LottieAnimationViewModule };
//# sourceMappingURL=lottieAnimationView.module.js.map
